import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"
import { cn } from "../../lib/utils"

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

// Radix sets data-state="closed" + hidden attribute when collapsed, but a `flex`/`grid`
// className on the content (common in this app's usage) overrides `[hidden]`'s display:none --
// data-[state=closed]:hidden guarantees it actually disappears regardless of the caller's own
// display utility.
const CollapsibleContent = ({ className, ...props }) => (
  <CollapsiblePrimitive.CollapsibleContent className={cn("data-[state=closed]:hidden", className)} {...props} />
)

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
